import React from 'react';
import { notifyViewFinishedLoading } from '@wix/business-manager-api';
import { create } from '@wix/fedops-logger';
import { COMPONENT_NAME } from '@src/config';
import { TabsPageComponent } from '../tabs-page/tabs-page.component';
import { BannerSettingsComponent } from '../banner-settings/banner-settings';
import { Route, Switch } from 'react-router-dom';
import { PageRoute } from '@src/types';
import { PageComponent } from '@src/components/page/page.container';
import { AdvancedOptionsComponent } from '../advanced-options/advanced-options';
import { AppContext } from '@src/context/store';
import { UnpublishedState } from '../unpublished-state/unpublished-state';
import { getIsSitePublished } from '@src/context/selectors/ui-settings';

interface Props {
  isSitePublished: boolean;
}

class AppComponent extends React.PureComponent<Props> {
  componentDidMount() {
    const fedopsLogger = create(COMPONENT_NAME);
    fedopsLogger.appLoaded();
    notifyViewFinishedLoading(COMPONENT_NAME);
  }

  render() {
    if (!this.props.isSitePublished) {
      return <UnpublishedState />;
    }

    return (
      <Switch>
        <PageComponent>
          <Route exact path={PageRoute.ROOT}>
            <TabsPageComponent />
          </Route>
          <Route path={PageRoute.BANNER_SETTINGS} exact>
            <BannerSettingsComponent />
          </Route>
          <Route path={PageRoute.ADVANCED_OPTIONS}>
            <AdvancedOptionsComponent />
          </Route>
        </PageComponent>
      </Switch>
    );
  }
}

export const App = () => {
  const store = React.useContext(AppContext);
  return <AppComponent isSitePublished={getIsSitePublished(store)} />;
};
